import React, { useCallback } from 'react';

//Hooks
import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory, Redirect, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

//Actions
import * as actions from '../../../../store/actions'

//Components
import { Container, Button } from 'react-bootstrap';
import Loader from 'react-loader-spinner';
import ServiceCategory from '../../../../components/ServiceCategory/ServiceCategory';
import ScreenFooter from '../../../../components/ScreenFooter/ScreenFooter';

import { ROUTER_URL } from '../../../../const/ROUTER_URL';

//Styles
import Styles from './Services.module.scss';

const Services = () => {
    const { shopId } = useParams();
    const categories = useSelector(state => state.booking.serviceCategories);
    const selectedServiceID = useSelector(state => state.booking.selectedServiceID);
    const { services: showServices } = useSelector(state => state.companies.shop ? state.companies.shop.products : { services: true });
    const [expanded, setExpanded] = useState(null);
    const style = useSelector(state => state.widget.style);
    const dispatch = useDispatch();

    const history = useHistory();
    const { t } = useTranslation('common');

    const useBookRedirect = useCallback(() => {
        history.push(ROUTER_URL.BOOK);
    }, [history]);

    useEffect(() => {
        dispatch(actions.selectGroup(null));
        dispatch(actions.selectBundle(null));
        dispatch(actions.selectEvent(null));
        dispatch(actions.selectService(null))
    }, [dispatch]);

    useEffect(() => {
        if (categories) {
            return;
        }

        dispatch(actions.getServices())
    }, [categories, dispatch]);

    if (!showServices) {
        return (
            <Redirect
                to={ROUTER_URL.SHOPS_ID_GROUPS({ shopId })}
                exact
            />
        );
    }

    if (!categories) {
        return (
            <div className={Styles.centeredContainer}>
                <Loader
                    type="TailSpin"
                    color="#000"
                    height={48}
                    width={48}
                />
            </div>
        );
    }

    return (
        <>
            <Container
                className={[
                    Styles.container,
                    'px-0',
                    (style === 'dev' || style === 'website') ? Styles.website : ''
                ].join(' ')}
                style={{ paddingBottom: (style === 'dev' || style === 'website') && !!selectedServiceID ? '112px' : '' }}
            >
                {Object.keys(categories).map((name, i) => (
                    <ServiceCategory
                        key={`category-${i}`}
                        name={name}
                        services={categories[name]}
                        expanded={expanded === name}
                        onExpandChanged={expanded => setExpanded(expanded ? name : null)}
                    />
                ))}
            </Container>

            <ScreenFooter visible={!!selectedServiceID}>
                <Button
                    variant={'tint'}
                    size={'lg'}
                    className={Styles.bookButton}
                    onClick={useBookRedirect}
                    data-testid='data-test-service-book-button'
                >
                    {t('homeScreen.makeABooking')}
                </Button>
            </ScreenFooter>
        </>
    );
};

export default Services
